/**
 * RobotPage — Current and previous robot showcase with season toggle.
 */
import React, { useState } from 'react';
import PageHeader from './PageHeader';
import styles from './RobotPage.module.css';

const ROBOTS = {
  current: {
    label: 'Current season',
    season: '2025–26',
    name: 'Decode',
    placeholder: 'Replace: Current season robot photo',
    description:
      'Built for speed and consistency — mecanum drive, dual intake, linear lift. Full CAD in OnShape; Java autonomous with vision-assisted scoring.',
    specs: [
      ['Drive', 'Mecanum'],
      ['Weight', '18 lbs'],
      ['Control', 'REV Hub + Expansion Hub'],
      ['Key mechanism', 'Dual intake + linear lift'],
    ],
  },
  previous: {
    label: 'Previous season',
    season: '2024–25',
    name: 'Prior build',
    placeholder: 'Replace: Previous season robot photo',
    description:
      'Tank-drive robot from last season. Simpler mechanism stack, strong reliability at regionals.',
    specs: [
      ['Drive', 'Tank'],
      ['Weight', '18 lbs'],
      ['Control', 'REV Hub'],
      ['Key mechanism', 'Single intake + arm'],
    ],
  },
};

function RobotPage() {
  const [active, setActive] = useState('current');
  const robot = ROBOTS[active];

  return (
    <div className={`roar-page ${styles.page}`}>
      <PageHeader
        eyebrow="Robot"
        title="Season builds"
        lead="One robot per year — designed, machined, wired, and programmed by students."
      />

      <div className={styles.layout}>
        <div className={styles.image}>{robot.placeholder}</div>

        <div>
          <div className={styles.toggle} role="tablist">
            {Object.entries(ROBOTS).map(([key, data]) => (
              <button
                key={key}
                type="button"
                role="tab"
                aria-selected={active === key}
                className={`${styles.toggleBtn} ${active === key ? styles.toggleBtnActive : ''}`}
                onClick={() => setActive(key)}
              >
                {data.label}
              </button>
            ))}
          </div>

          <p className={styles.season}>{robot.season}</p>
          <h2 className={styles.robotName}>{robot.name}</h2>
          <p className={styles.desc}>{robot.description}</p>

          <ul className={styles.specs}>
            {robot.specs.map(([label, value]) => (
              <li key={label}>
                <span className={styles.specLabel}>{label}</span>
                <span>{value}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
}

export default RobotPage;
